import { ASSET_DESKTOP, ASSET_MOBILE, PREVIEW_IMAGE_DESKTOP, PREVIEW_IMAGE_MOBILE } from '../elements/assets'

export const HERO_SECTION_V2 = `
...on heroSectionV2_Entry {
  id
  typeHandle

  heading {
    html
  }
  subheading

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }
  ${ PREVIEW_IMAGE_DESKTOP }
  ${ PREVIEW_IMAGE_MOBILE }

  videoUrl {
    url
  }
}
`